import { createFileRoute } from "@tanstack/react-router"
import { LoginPage } from "@/app"

export const Route = createFileRoute("/(public)/auth/login")({
  component: RouteComponent,
  validateSearch: (search) => search as { email?: string },
})

function RouteComponent() {
  const { email } = Route.useSearch()

  return <LoginPage email={email} />
}
